import {store} from '../store/global-store';

export const advertActions = {
    openCopyAsModal(model) {
        store.commit('openCopyAsModal', model);
    },
    closeCopyAsModal() {
        store.commit('closeCopyAsModal');
    },
    openDeleteModal(model) {
        store.commit('openDeleteModal', model);
    },
    openConfirmAdvertDeleteModal(model) {
        store.commit('openConfirmAdvertDeleteModal', model);
    },
    openSoldModal(model) {
        store.commit('openSoldModal', model);
    },
    closeSoldModal() {
        store.commit('closeSoldModal');
    },
    openRentedModal(model) {
        store.commit('openRentedModal', model);
    },
    closeRentedModal() {
        store.commit('closeRentedModal');
    },
    openHideModal(acceptAction, cancelAction) {
        store.commit('openHideModal', {acceptAction, cancelAction});
    },
};
